import GoalError from './GoalError';
class ProjectedTimeExceedsLimit extends GoalError {
    constructor(options) {
        super('The projected time to goal exceeds the established limit', options);
    }
}
export default ProjectedTimeExceedsLimit;
